module.exports = __webpack_public_path__ + "static/media/unsent1_img.16997670.png";